module.exports = __webpack_public_path__ + "static/media/chart.e2e381b5.svg";